import React from "react";
import {
  Box,
  TextField,
  Button,
  MenuItem,
  FormControl,
  Select,
  IconButton,
  Tooltip,
  InputAdornment,
  CircularProgress,
  FormControlLabel,
  Switch,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";

export default function LeasecontrolUsuariosToolbar({
  search,
  onSearchChange,
  limit,
  onLimitChange,
  onRefresh,
  onCreate,
  loading,

  // ✅ nuevos props (opcionales)
  groupBy = false,
  onGroupByChange,
}) {
  return (
    <Box
      sx={{
        p: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        bgcolor: "background.paper",
        borderBottom: "1px solid",
        borderColor: "divider",
        flexWrap: "wrap", // ✅ por si en pantallas pequeñas se rompe
      }}
    >
      {/* Grupo Izquierdo: Buscador y Select */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        <TextField
          size="small"
          placeholder="Buscar..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          sx={{
            width: 200,
            "& .MuiInputBase-root": { height: 35, fontSize: "0.85rem" },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        <FormControl size="small">
          <Select
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            sx={{
              height: 35,
              fontSize: "0.85rem",
              minWidth: 90,
              backgroundColor: "background.paper",
            }}
          >
            {[25, 50, 100].map((v) => (
              <MenuItem key={v} value={v} sx={{ fontSize: "0.85rem" }}>
                {v} filas
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* ✅ Switch Agrupar */}
        <FormControlLabel
          sx={{ ml: 0.5, userSelect: "none" }}
          control={
            <Switch
              size="small"
              checked={!!groupBy}
              onChange={(e) => onGroupByChange?.(e.target.checked)}
              disabled={loading}
            />
          }
          label="Agrupar"
        />
      </Box>

      {/* Grupo Derecho: Acciones */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Tooltip title="Actualizar">
          <IconButton
            onClick={onRefresh}
            disabled={loading}
            size="small"
            sx={{
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              height: 35,
              width: 35,
            }}
          >
            {loading ? <CircularProgress size={18} /> : <RefreshIcon fontSize="small" />}
          </IconButton>
        </Tooltip>

        {typeof onCreate === "function" && (
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={onCreate}
            disableElevation
            sx={{
              height: 35,
              textTransform: "none",
              fontWeight: "bold",
              borderRadius: 1.5,
              px: 2,
            }}
          >
            Nuevo
          </Button>
        )}
      </Box>
    </Box>
  );
}
